import { createContext } from "react";

export const activeJourneyContext = createContext<any>({});